document.addEventListener('DOMContentLoaded', function() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      console.log('isSafari:', isSafari)
      // --- Константы для замены эмодзи ---
      const EMOJI_REPLACEMENTS = {
        "{heart}": "🫶",
        "{love}": "😍",
        "{lips}": "🫦",
        "{redheart}": "🤍",
        "{poop}": "💩",
        "{skull}": "💀",
        "{clown}": "🤡",
        "{cat}": "😺",
        "{nails}": "💅",
        "{money}": "🤑",
        "{devil}": "😈",
        "{fire}": "🔥"
      };
  
      // --- Маппинг кодов на URL изображений ---
      const EMOJI_IMAGES = {
        "{heart}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/heart.png?v=1751363260",
        "{love}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/love.png?v=1751362921",
        "{lips}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/lips.png?v=1751363261",
        "{redheart}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/redheart.png?v=1751362920",
        "{poop}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/poop.png?v=1751362921",
        "{skull}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/skull.png?v=1751362920",
        "{cat}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/cat.png?v=1751362920",
        "{money}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/money.png?v=1751362920",
        "{devil}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/devil.png?v=1751362921",
        "{fire}": "https://cdn.shopify.com/s/files/1/0789/1386/3964/files/fire.png?v=1751362920"
      };
    
      // --- Функция для конвертации эмодзи в коды ---
      function emojiToCode(text) {
        let result = text;
        Object.entries(EMOJI_REPLACEMENTS).forEach(([code, emoji]) => {
          result = result.replace(new RegExp(emoji, 'g'), code);
        });
        return result;
      }
    
      // --- Функция для конвертации кодов в эмодзи ---
      function codeToEmoji(text) {
        let result = text;
        Object.entries(EMOJI_REPLACEMENTS).forEach(([code, emoji]) => {
          result = result.replace(new RegExp(code.replace(/[{}]/g, '\\$&'), 'g'), emoji);
        });
        return result;
      }
    
      // --- Функция для очистки ввода от запрещенных символов ---
      function cleanInput(text) {
        // убираем запрещённые символы: {}, / и "
        return text.replace(/[{}\/"]/g, '');
      }
  
      // --- Функция для проверки разрешенных эмодзи ---
      function isAllowedEmoji(char) {
        return Object.values(EMOJI_REPLACEMENTS).includes(char);
      }
    
      // --- Функция для преобразования в uppercase латиницу ---
      const layoutMap = {
        'й': 'q', 'ц': 'w', 'у': 'e', 'к': 'r', 'е': 't', 'н': 'y', 'г': 'u', 'ш': 'i', 'щ': 'o', 'з': 'p',
        'х': '[', 'ъ': ']', 'ф': 'a', 'ы': 's', 'в': 'd', 'а': 'f', 'п': 'g', 'р': 'h', 'о': 'j', 'л': 'k',
        'д': 'l', 'ж': ';', 'э': "'", 'я': 'z', 'ч': 'x', 'с': 'c', 'м': 'v', 'и': 'b', 'т': 'n', 'ь': 'm',
        'б': ',', 'ю': '.', 'ё': '`',
      
        // верхний регистр
        'Й': 'Q', 'Ц': 'W', 'У': 'E', 'К': 'R', 'Е': 'T', 'Н': 'Y', 'Г': 'U', 'Ш': 'I', 'Щ': 'O', 'З': 'P',
        'Х': '{', 'Ъ': '}', 'Ф': 'A', 'Ы': 'S', 'В': 'D', 'А': 'F', 'П': 'G', 'Р': 'H', 'О': 'J', 'Л': 'K',
        'Д': 'L', 'Ж': ':', 'Э': '"', 'Я': 'Z', 'Ч': 'X', 'С': 'C', 'М': 'V', 'И': 'B', 'Т': 'N', 'Ь': 'M',
        'Б': '<', 'Ю': '>', 'Ё': '~'
      };
      
      function toUppercaseLatin(text) {
        let result = '';
        for (let char of text) {
          // если символ есть в мапе — заменяем
          if (layoutMap[char]) {
            result += layoutMap[char];
          } else {
            result += char;
          }
        }
      
        // теперь убираем всё, что не латиница, цифры, пробелы или спецсимволы
        result = result.replace(/[^a-zA-Z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g, '');
      
        // и приводим к верхнему регистру
        return result.toUpperCase();
      }
    
      // --- Обновление атрибута engraving в корзине ---
      let isUpdatingAttributes = false; // Флаг для предотвращения одновременных вызовов
      
      function updateEngravingAttributes() {
        // Предотвращаем одновременные вызовы
        if (isUpdatingAttributes) {
          console.log('[engraving] Обновление атрибутов уже выполняется, пропускаем');
          return;
        }
        
        const skuSpan = document.querySelector('#spanSKU');
        const sku = skuSpan ? skuSpan.innerText.trim() : 'UNKNOWN';
        const engravingValue = lastSavedValue;
        
        isUpdatingAttributes = true;
    
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            let engraving = {};
            if (cart.attributes && cart.attributes.engraving) {
              try {
                engraving = JSON.parse(cart.attributes.engraving);
              } catch (e) {
                console.error('[engraving] Ошибка парсинга engraving:', e, cart.attributes.engraving);
              }
            }
            
            // Очищаем неактуальные гравировки для товаров, которых больше нет в корзине
            const cartSkus = cart.items.map(item => item.sku).filter(sku => sku);
            Object.keys(engraving).forEach(existingSku => {
              if (!cartSkus.includes(existingSku)) {
                delete engraving[existingSku];
              }
            });
            
            // Если гравировка пустая - удаляем её из атрибутов
            if (!engravingValue || engravingValue.trim() === '') {
              console.log('[engraving] Удаляем гравировку для SKU:', sku);
              delete engraving[sku];
            } else {
              // Конвертируем эмодзи в коды перед сохранением в атрибуты
              const engravingForAttributes = emojiToCode(engravingValue);
                engraving[sku] = {
                text: engravingForAttributes,
                font: selectedFont
              };
              console.log('[engraving] Сохраняем гравировку для SKU:', sku, 'текст:', engravingForAttributes, 'шрифт:', selectedFont);
            }
            
            const newAttributes = {
              ...cart.attributes,
              engraving: JSON.stringify(engraving)
            };
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: newAttributes })
            })
              .then(res => res.json())
              .catch(err => {
                console.error('[engraving] Ошибка при обновлении cart/update.js:', err);
              });
          })
          .catch(err => {
            console.error('[engraving] Ошибка при получении cart.js:', err);
          })
          .finally(() => {
            isUpdatingAttributes = false; // Сбрасываем флаг в любом случае
          });
      }
    
      // --- Проверка существующей гравировки в корзине ---
      function checkExistingEngraving() {
        const skuSpan = document.querySelector('#spanSKU');
        const sku = skuSpan ? skuSpan.innerText.trim() : 'UNKNOWN';
        
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            if (cart.attributes && cart.attributes.engraving) {
              try {
                const engraving = JSON.parse(cart.attributes.engraving);
                
                if (engraving[sku]) {
                  const existingValue = engraving[sku];
                  
                  let textValue = '';
                  let fontValue = 'arial';
                  
                  // Поддерживаем как старый формат (строка), так и новый (объект)
                  if (typeof existingValue === 'string') {
                    // Старый формат - просто строка
                    textValue = existingValue;
                  } else if (typeof existingValue === 'object' && existingValue !== null) {
                    // Новый формат - объект с text и font
                    textValue = existingValue.text || existingValue;
                    fontValue = existingValue.font || existingValue.font_key || 'arial';
                  }
                  
                  // Конвертируем коды обратно в эмодзи для отображения
                  const displayValue = codeToEmoji(textValue);
                  
                  // Восстанавливаем выбранный шрифт
                  selectedFont = fontValue;
                  const fontKeyForSelector = fontValue === 'arial' ? 'default' : fontValue;
                  selectFont(fontKeyForSelector);
                    
                  // Обновляем состояние UI
                  lastSavedValue = displayValue;
                  if (engraveInput) engraveInput.value = displayValue;
                  if (engravePreviewSelected) {
                    engravePreviewSelected.dataset.value = displayValue;
                    engravePreviewSelected.innerHTML = 'Twój wybrany grawerunek: <strong>' + displayValue + '</strong>';
                  }
                  
                  // Обновляем превью
                  updatePreview();
                  
                  // Меняем состояние кнопки на "Edit Engraving"
                  if (engravingOption) {
                    const title = engravingOption.querySelector('.engrave-option-title');
                    if (title) title.innerHTML = 'Edytuj grawerunek <span class="engrave-price">+25zł</span>';
                    engravingOption.classList.add('engrave-added');
                  }
                  
                  // Показываем +0€ рядом с ценой
                  updatePriceAddon(true);
                }
              } catch (e) {
                console.error('[engraving] Ошибка парсинга существующего engraving:', e);
              }
            }
          })
          .catch(err => {
            console.error('[engraving] Ошибка при проверке существующей гравировки:', err);
          });
      }
      
    (function () {
      // Флаг для отслеживания уже добавленных обработчиков
      let fetchIntercepted = false;
      let xhrIntercepted = false;
  
      if (typeof window.fetch !== 'undefined' && !fetchIntercepted) {
        const origFetch = window.fetch;
        window.fetch = function (...args) {
          const [url] = args;
          const isCartAdd = typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'));
  
          return origFetch.apply(this, args).then(response => {
            if (isCartAdd && response.ok) {
              // Добавляем небольшую задержку для избежания конфликтов
              setTimeout(() => {
                try {
                  updateEngravingAttributes();
                } catch (error) {
                  console.error('[engraving] Ошибка в updateEngravingAttributes после fetch:', error);
                }
              }, 100);
            }
            return response;
          }).catch(error => {
            console.error('[engraving] Ошибка в перехваченном fetch:', error);
            throw error; // Пробрасываем ошибку дальше
          });
        };
        fetchIntercepted = true;
      }
  
      if (!xhrIntercepted) {
        const origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
          const isCartAdd = typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'));
  
          if (isCartAdd) {
            // Проверяем, не добавлен ли уже обработчик
            if (!this._engravingHandlerAdded) {
              this.addEventListener('load', function () {
                if (this.status >= 200 && this.status < 300) {
                  setTimeout(() => {
                    try {
                      updateEngravingAttributes();
                    } catch (error) {
                      console.error('[engraving] Ошибка в updateEngravingAttributes после XHR:', error);
                    }
                  }, 100);
                }
              });
              this._engravingHandlerAdded = true;
            }
          }
  
          return origOpen.apply(this, arguments);
        };
        xhrIntercepted = true;
      }
  
      // Убираем fallback обработчики, которые могут создавать конфликты
      // document.addEventListener('submit', function (e) {
      //   if (e.target.action && e.target.action.includes('/cart/add')) {
      //     setTimeout(updateEngravingAttributes, 300);
      //   }
      // });
  
      // document.addEventListener('click', function (e) {
      //   if (e.target.matches('[data-action="add-to-cart"], .add-to-cart, button[type="submit"]')) {
      //     setTimeout(updateEngravingAttributes, 300);
      //   }
      // });
    })();
    
      function debugEmojiInput() {
      const value = engraveInput.value;
      const inputValue = document.getElementById('debugInputValue');
      const unicodeCodes = document.getElementById('debugUnicodeCodes');
      const previewText = document.getElementById('debugPreviewText');
      const previewHTML = document.getElementById('debugPreviewHTML');
    
      // 1. Отобразим оригинальный текст
      inputValue.textContent = value;
    
      // 2. Разложим по символам и покажем юникоды
      const codes = [...value].map(char => {
        return `U+${char.codePointAt(0).toString(window.ShopifyEngravingData.maxSymbols).toUpperCase()}`;
      });
      unicodeCodes.textContent = codes.join(' ');
    
      // 3. Прочитаем textContent и innerHTML превью
      const preview = document.getElementById('engravePreview');
      previewText.textContent = preview.textContent;
      previewHTML.textContent = preview.innerHTML;
    }
    
      const options = document.querySelectorAll('.engrave-option');
      // Найти стандартную кнопку покупки Shopify
      // let buyBtn = document.querySelector('.product-form__submit, .shopify-payment-button__button, button[type=submit]');
      // --- визуальное отображение +25zł рядом с ценой ---
      function updatePriceAddon(show) {
        // Ищем контейнер цены более гибко
        const priceContainer = document.querySelector('.price-item, .price, .product__price, [data-price]');
        if (!priceContainer) {
          console.log('[engraving] Контейнер цены не найден');
          return;
        }
      
        let addonEl = priceContainer.querySelector('.engraving-addon-price');
        if (!addonEl) {
          addonEl = document.createElement('span');
          addonEl.className = 'engraving-addon-price';
          addonEl.style.marginLeft = '8px';
          addonEl.style.color = '#0071e3';
          addonEl.style.fontWeight = 600;
          addonEl.style.fontSize = 'inherit';
          priceContainer.appendChild(addonEl);
        }
      
        addonEl.textContent = show ? '+25zł' : '';
        console.log('[engraving] Обновлен addon цены:', show ? '+25zł' : 'скрыт');
      }
    
    // --- Гравировка ---
    const engravingOption = document.getElementById('engravingOption');
    const popupOverlay = document.getElementById('popupOverlay');
    const closePopupBtn = document.getElementById('closePopupBtn');
    const cancelPopupBtn = document.getElementById('cancelPopupBtn');
    const saveEngraveBtn = document.getElementById('saveEngraveBtn');
    const engraveInput = document.getElementById('engraveInput');
    const engravePreview = document.getElementById('engravePreview');
    const engravePreviewSelected = document.getElementById('engravePreviewSelected');
    const emojiList = document.getElementById('emojiList');
    let lastSavedValue = engravePreviewSelected ? (engravePreviewSelected.dataset.value || '') : '';
    let selectedFont = 'arial'; // По умолчанию arial (default)
    let confirmPopup = null;
    
    // --- Инициализация селектора шрифтов ---
    const fontOptions = document.querySelectorAll('.font-option');
    const fontSelector = document.querySelector('.font-selector');
    
    // Функция для получения максимального количества символов с учетом выбранного шрифта
    function getMaxSymbols() {
      const baseMax = window.ShopifyEngravingData ? window.ShopifyEngravingData.maxSymbols : 20;
      
      // Если выбран курсив, уменьшаем максимальное количество символов
      if (selectedFont === 'cursive') {
        if (baseMax <= 6) {
          return Math.max(1, baseMax - 2); // Разрешаем 4 при максимуме 6
        } else if (baseMax >= 7 && baseMax <= 10) {
          return Math.max(1, baseMax - 4); // Уменьшаем на 3
        } else if (baseMax > 15) {
          return Math.max(1, baseMax - 8); // Уменьшаем на 5
        } else {
          // Для 11-15 уменьшаем на 4 (логично между 3 и 5)
          return Math.max(1, baseMax - 4);
        }
      }
      
      return baseMax;
    }
    
    // Функция для выбора шрифта
    function selectFont(fontKey) {
      selectedFont = fontKey === 'default' ? 'arial' : fontKey;
      
      // Обновляем визуальное состояние кнопок (если они существуют)
      const currentFontOptions = document.querySelectorAll('.font-option');
      if (currentFontOptions.length > 0) {
        currentFontOptions.forEach(btn => {
          if (btn.dataset.font === fontKey) {
            btn.classList.add('selected');
          } else {
            btn.classList.remove('selected');
          }
        });
      }
      
      // Проверяем и обрезаем текст, если он превышает новый лимит
      if (engraveInput && engraveInput.value.length > getMaxSymbols()) {
        engraveInput.value = engraveInput.value.slice(0, getMaxSymbols());
        updatePreview();
      }
      
      console.log('[engraving] Выбран шрифт:', selectedFont);
      console.log('[engraving] Максимальное количество символов:', getMaxSymbols());
    }
    
    // Обработчики для кнопок выбора шрифта
    if (fontOptions.length > 0) {
      fontOptions.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.stopPropagation(); // Предотвращаем всплытие события
          const fontKey = btn.dataset.font;
          selectFont(fontKey);
        });
      });
      
      // Устанавливаем начальное состояние (default selected)
      const defaultBtn = document.querySelector('.font-option.default');
      if (defaultBtn) {
        selectFont('default');
      }
    }
  
    // --- Открытие попапа по клику на всю engrave-option ---
    if (engravingOption) {
      engravingOption.addEventListener('click', function(e) {
        // Не открываем попап, если клик был по селектору шрифта
        if (e.target.closest('.font-selector')) {
          return;
        }
        popupOverlay.style.display = 'flex';
        engraveInput.value = engravePreviewSelected.dataset.value || '';
        lastSavedValue = engraveInput.value;
        updatePreview();
      });
    }
  
    // --- Функция для отслеживания изменений SKU ---
    function setupSkuObserver() {
      const skuSpan = document.querySelector('#spanSKU');
      if (!skuSpan) return;
      
      // Создаем MutationObserver для отслеживания изменений в spanSKU
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            console.log('[engraving] SKU изменился, обновляем состояние гравировки');
            // Сбрасываем состояние гравировки при смене варианта
            lastSavedValue = '';
            selectedFont = 'arial'; // Сбрасываем шрифт на default
            selectFont('default'); // Обновляем визуальное состояние
            if (engraveInput) engraveInput.value = '';
              if (engravePreviewSelected) {
                engravePreviewSelected.dataset.value = '';
                engravePreviewSelected.innerHTML = 'Dodaj grawer <span class="engrave-price">+25zł</span>';
              }
              
              // Обновляем состояние кнопки
              if (engravingOption) {
                const title = engravingOption.querySelector('.engrave-option-title');
                if (title) title.innerHTML = 'Dodaj grawer <span class="engrave-price">+25zł</span>';
                engravingOption.classList.remove('engrave-added');
              }
            
            // Скрываем +0€ рядом с ценой
            updatePriceAddon(false);
            
            // Обновляем превью
            updatePreview();
            
            // Проверяем существующую гравировку для нового SKU
            setTimeout(checkExistingEngraving, 100);
          }
        });
      });
      
      // Начинаем наблюдение за изменениями
      observer.observe(skuSpan, {
        childList: true,
        characterData: true,
        subtree: true
      });
      
      console.log('[engraving] Наблюдатель за SKU установлен');
    }
    
      
      // --- Проверяем существующую гравировку при загрузке страницы ---
      checkExistingEngraving();
      
      // --- Устанавливаем наблюдатель за изменениями SKU ---
      setupSkuObserver();
      
      // --- Наблюдатель за изменениями DOM для восстановления addon цены ---
      function setupPriceObserver() {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              // Проверяем, не исчез ли наш addon цены
              const priceContainer = document.querySelector('.price-item, .price, .product__price, [data-price]');
              if (priceContainer && !priceContainer.querySelector('.engraving-addon-price')) {
                // Если есть активная гравировка, восстанавливаем addon
                if (lastSavedValue && lastSavedValue.trim() !== '') {
                  console.log('[engraving] Восстанавливаем addon цены после обновления DOM');
                  updatePriceAddon(true);
                }
              }
            }
          });
        });
        
        // Наблюдаем за изменениями в body
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
        
        console.log('[engraving] Наблюдатель за ценой установлен');
      }
      
      // --- Устанавливаем наблюдатель за изменениями цены ---
      setupPriceObserver();
    
      // --- Confirm popup ---
      function showConfirmPopup(onConfirm, onCancel) {
        if (confirmPopup) return;
        confirmPopup = document.createElement('div');
        confirmPopup.className = 'popup-overlay confirm-popup';
        confirmPopup.innerHTML = `
          <div class="popup">
            <button class="popup-close confirm-close" style="position:absolute;top:18px;right:18px;font-size:24px;background:none;border:none;cursor:pointer;">&times;</button>
            <div class="popup-header" style="font-size:20px;">Odrzucić zmiany?</div>
            <div class="popup-desc" style="margin:10px 0 20px 0;">Wprowadziłeś zmiany w grawerunku. Na pewno chcesz wyjść bez zapisania?</div>
            <div class="popup-actions">
              <button class="popup-cancel confirm-cancel">Kontynuuj edycję</button>
              <button class="popup-save confirm-leave" style="background:#e33c00;">Odrzuć</button>
            </div>
          </div>
        `;
        document.body.appendChild(confirmPopup);
        
        // Добавляем обработчики событий
        confirmPopup.querySelector('.confirm-cancel').onclick = function() {
          document.body.removeChild(confirmPopup); 
          confirmPopup = null; 
          if (onCancel) onCancel();
        };
        confirmPopup.querySelector('.confirm-close').onclick = function() {
          document.body.removeChild(confirmPopup); 
          confirmPopup = null; 
          if (onCancel) onCancel();
        };
        confirmPopup.querySelector('.confirm-leave').onclick = function() {
          document.body.removeChild(confirmPopup); 
          confirmPopup = null; 
          if (onConfirm) onConfirm();
        };
      }
    
      function tryClosePopup() {
        if (engraveInput.value !== lastSavedValue) {
          showConfirmPopup(() => {
            engraveInput.value = lastSavedValue;
            updatePreview();
            popupOverlay.style.display = 'none';
          }, null);
        } else {
          popupOverlay.style.display = 'none';
        }
      }
    
      if (closePopupBtn) closePopupBtn.onclick = tryClosePopup;
      if (cancelPopupBtn) cancelPopupBtn.onclick = tryClosePopup;
      if (popupOverlay) {
        popupOverlay.addEventListener('click', function(e) {
          if (e.target === popupOverlay) tryClosePopup();
        });
      }
    
      // --- Сохранить гравировку ---
      if (saveEngraveBtn) {
        saveEngraveBtn.onclick = function() {
          const value = engraveInput.value.trim();
          if (value) {
            const title = engravingOption.querySelector('.engrave-option-title');
            if (title) title.innerHTML = 'Edytuj grawerunek <span class="engrave-price">+25zł</span>';
            engravingOption.classList.add('engrave-added');
          } else {
            const title = engravingOption.querySelector('.engrave-option-title');
            if (title) title.innerHTML = 'Dodaj grawer <span class="engrave-price">+25zł</span>';
            engravingOption.classList.remove('engrave-added');
          }
          updatePriceAddon(!!value);
          lastSavedValue = value;
          popupOverlay.style.display = 'none';
    
          // Обновляем превью выбранной гравировки
          if (engravePreviewSelected) {
            engravePreviewSelected.innerHTML = '<strong>Twój wybrany grawerunek: ' + value + '</strong>';
            engravePreviewSelected.dataset.value = value;
          }
  
          // Обновляем атрибуты корзины только если товар уже в корзине с гравировкой
          const skuSpan = document.querySelector('#spanSKU');
          const sku = skuSpan ? skuSpan.innerText.trim() : 'UNKNOWN';
          
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              // Проверяем, есть ли товар в корзине
              const cartItem = cart.items.find(item => item.sku === sku);
              if (cartItem) {
                // Если товар в корзине, обновляем атрибуты
                console.log('[engraving] Товар в корзине, обновляем гравировку:', value);
                updateEngravingAttributes();
              } else {
                // Если товар не в корзине, просто сохраняем локально для будущего добавления
                console.log('[engraving] Товар не в корзине, сохраняем локально:', value);
              }
            })
            .catch(err => {
              console.error('[engraving] Ошибка при проверке корзины:', err);
            });
        };
      }
    
    
    function isEmoji(char) {
      const emojiRegex = /\p{Extended_Pictographic}/u;
      return emojiRegex.test(char);
    }
    
    const monochromize = (emoji) => {
      const codepoints = Array.from(emoji).map(char => {
        const int = char.codePointAt(0);
        return int === 65039 ? 65038 : int;
      });
      return String.fromCodePoint(...codepoints);
    };
    
    const engravePreviewOutput = document.querySelector('.engrave-text')
      
    // function updatePreview() {
    //   const value = engraveInput.value;
    //   engravePreviewOutput.textContent = monochromize(value);
    // }
    
        function updatePreview() {
      const value = engraveInput.value;
      engravePreview.innerHTML = '';
  
      const span = document.createElement('span');
      span.className = 'engrave-preview-elements';
  
      for (let char of [...value]) {
        const innerSpan = document.createElement('span');
  
        if (char === ' ') {
          innerSpan.innerHTML = '&nbsp;';
          innerSpan.style.minWidth = '0.5em';
          innerSpan.style.display = 'inline-block';
        } else if (isEmoji(char)) {
          // Проверяем, разрешен ли эмодзи
          if (isAllowedEmoji(char)) {
            innerSpan.className = 'engrave-emoji';
            // Находим код для этого эмодзи
            const emojiCode = Object.keys(EMOJI_REPLACEMENTS).find(key => EMOJI_REPLACEMENTS[key] === char);
            if (emojiCode && EMOJI_IMAGES[emojiCode]) {
              const img = document.createElement('img');
              img.src = EMOJI_IMAGES[emojiCode];
              img.style.verticalAlign = 'middle';
              innerSpan.appendChild(img);
            } else {
              innerSpan.textContent = char;
            }
          } else {
            // Если эмодзи не разрешен, не отображаем его
            continue;
          }
        } else {
          innerSpan.className = 'engrave-text';
          innerSpan.textContent = char;
        }
  
        span.appendChild(innerSpan);
      }
  
      engravePreview.appendChild(span);
    }
    
    
    
      if (emojiList && engraveInput) {
        emojiList.addEventListener('click', function(e) {
          // Находим ближайшую кнопку эмодзи (клик может быть по img внутри кнопки)
          const emojiBtn = e.target.closest('.emoji-btn');
          if (emojiBtn) {
            const emojiCode = emojiBtn.dataset.code;
            const emoji = EMOJI_REPLACEMENTS[emojiCode];
            if (!emoji) return;
            
            const start = engraveInput.selectionStart;
            const end = engraveInput.selectionEnd;
            const value = engraveInput.value;
            if (value.length - (end - start) + emoji.length > getMaxSymbols()) return;
            engraveInput.value = value.slice(0, start) + emoji + value.slice(end);
            engraveInput.focus();
            engraveInput.selectionStart = engraveInput.selectionEnd = start + emoji.length;
            updatePreview();
          }
        });
        
        // для контроля и фильтрации ввода
        engraveInput.addEventListener('beforeinput', function(e) {
          if (e.inputType === 'insertText' || e.inputType === 'insertFromPaste') {
            const inputText = e.data;
            
            // Проверяем каждый символ
            let allowedText = '';
            for (let char of inputText) {
              if (isEmoji(char)) {
                // Если это эмодзи, проверяем разрешен ли он
                if (isAllowedEmoji(char)) {
                  allowedText += char;
                }
                // Если не разрешен, просто пропускаем
              } else {
                // Для обычного текста применяем стандартную очистку
                const cleanedChar = cleanInput(toUppercaseLatin(char));
                if (cleanedChar) {
                  allowedText += cleanedChar;
                }
              }
            }
        
            if (!allowedText) {
              e.preventDefault();
              return;
            }
        
            const start = engraveInput.selectionStart;
            const end = engraveInput.selectionEnd;
            const currentValue = engraveInput.value;
        
            const newValue = currentValue.slice(0, start) + allowedText + currentValue.slice(end);
        
            if (newValue.length <= getMaxSymbols()) {
              e.preventDefault();
              engraveInput.value = newValue;
              engraveInput.selectionStart = engraveInput.selectionEnd = start + allowedText.length;
              updatePreview();
            } else {
              e.preventDefault();
            }
          }
        });
        
        // отдельный listener для обновления превью при любом изменении (включая backspace/delete)
        engraveInput.addEventListener('input', function () {
          updatePreview();
        });
    
        
      }
    }); 
    
    // Убираем постоянную проверку корзины, которая может создавать конфликты
    // setInterval(() => {
    //   fetch('/cart.js')
    //     .then((res) => res.json())
    //     .then((cart) => {
    //       console.log('🛒 Cart:', cart);
    //     })
    //     .catch((err) => console.error('Ошибка при получении cart.js', err));
    // }, 5000);